import GrayCard from "components/gray-card";
import Dropdown from "components/inputs/dropdown";
import Typography from "components/typography";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  setMedia: (value: any) => void;
  media?: any;
}
const TvPromo = ({ setMedia, media }: IProps) => {
  const TVItems: string[] = ["Music"];
  return (
    <GrayCard title="TV Promo">
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Pick a video you want to promote
      </Typography>

      <DropdownContainer>
        <Dropdown
          placeholder="Choose A Video"
          chosenItem={media ? media : ""}
          selectItem={(value) => {
            setMedia(value);
          }}
          items={TVItems}
        />
      </DropdownContainer>
    </GrayCard>
  );
};

export default TvPromo;

const DropdownContainer = styled.div`
  width: 30rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
